import { render } from "./CatalogProductCard.vue?vue&type=template&id=ea9ac9f2&scoped=true"
import script from "./CatalogProductCard.vue?vue&type=script&lang=js"
export * from "./CatalogProductCard.vue?vue&type=script&lang=js"

import "./CatalogProductCard.vue?vue&type=style&index=0&id=ea9ac9f2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea9ac9f2"]])

export default __exports__